import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Gesture, GitHub, Instagram, Twitter, Upload, YouTube } from "@mui/icons-material";
import { useUser } from "../context/UserContext";
import { handleLogout } from "../utils/handleLogout";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import SEO from "../config/SEO";
import Profile from "./Profile";
import Prompt24Item from "../smallComponets/Prompt24Item";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPlanIcon } from "../utils/DynamicUniversalFunctions";


function ProfilePreview() {

     const { userData, followersCount, followingCount } = useUser();

     const socialIcons = {
          instagram: <Instagram />,
          twitter: <Twitter />,
          youtube: <YouTube />,
          facebook: <Facebook />,
          github: <GitHub />,
          threads: <Gesture />
     };


     // states

     const [show, setShow] = useState(false);
     const handleClose = () => setShow(false);
     const handleShow = () => setShow(true);
     const [message, setMessage] = useState("");
     // const expiryDate = getExpiryDate(last_package?.planTimestamp, last_package?.planTitle);


     return (
          <>

               <SEO
                    title="User Profile - Manage Your HeyPrompt Identity"
                    description="Access and edit your profile details, social links, bio and attribution information. Build your creator identity and improve visibility across the HeyPrompt ecosystem."
                    keywords={[
                         "HeyPrompts profile",
                         "prompt creator profile",
                         "AI creator identity",
                         "profile management",
                         "user settings",
                         "social links AI",
                         "attribution profile",
                         "prompt marketplace profile",
                         "HeyPrompt gallery profile",
                         "prompt portfolio",
                         "profile edit AI",
                         "bio and social links",
                         "user AI profile",
                         "manage profile",
                         "AI content identity"
                    ]}
               />


               <div className="user-profile">

                    <div className="user-profile-container">
                         <div className="profile-header">


                              <div className="profile-left">
                                   <img src={userData?.photoURL || `https://api.dicebear.com/7.x/avataaars/svg?seed=user${userData?.username}`} alt={userData?.name} />

                                   <div className="profile-info">
                                        <h1>{userData?.name}
                                             <OverlayTrigger
                                                 placement="top" 
                                                 overlay={
                                                   <Tooltip id="plan-tooltip">
                                                     {userData?.planDetails?.planTitle} Plan Active
                                                   </Tooltip>
                                                 }
                                               >
                                                 <span className='d-inline-block ms-1'>{getPlanIcon(userData?.planDetails?.planTitle)}</span>
                                               </OverlayTrigger>
                                        </h1>
                                        <div className="meta">
                                             <span>#{userData?.username}</span>
                                             <span>{followersCount} followers</span>
                                             <span>{followingCount} following</span>
                                        </div>

                                        <div className="streak">☀ role : {userData?.role || "User"} </div>
                                   </div>
                              </div>

                              <div className="profile-right">
                                   <button className="edit-btn" disabled={message ? true : false} onClick={handleShow}>Edit my profile</button>
                              </div>

                         </div>

                         {userData?.subscriptions === "paid" &&
                              <div className="alert alert-warning active-plan mt-5">Your subscription is active. Thank you for supporting us!</div>
                         }

                         {message && (
                              <div className="alert alert-danger active-plan mt-4">{message}</div>
                         )}

                         <Tabs>
                              <TabList>
                                   <Tab>Information</Tab>
                                   <Tab>Payments</Tab>
                              </TabList>

                              <TabPanel>
                                   <div className="section border-0 mt-0">
                                        <p>
                                             About: {userData?.about || "This user hasn't added an about section yet."}
                                        </p>
                                        <p>
                                             Website: <Link to={userData?.website} target="_blank" rel="noopener noreferrer">{userData?.website}</Link>
                                        </p>
                                        <div className="items">
                                             <span>email : {userData?.email}</span>
                                             <span>city : {userData?.city}</span>
                                             <span>phone : {userData?.phone}</span>
                                             <span>subscriptions : {userData?.subscriptions}</span>
                                             {/* <span>payment : {userData?.payment}</span> */}
                                             <span>last sign in : {userData?.lastSignIn}</span>
                                        </div>
                                   </div>


                                   <div className="section">
                                        <h3>Badges</h3>

                                        <div className="badge-row">
                                             {userData?.isPremium &&
                                                  <div className="badge-item">
                                                       <div className="badge-icon golden">▲</div>
                                                       <div className="badge-text">
                                                            <strong>Premium Creator</strong>
                                                       </div>
                                                  </div>
                                             }
                                             <div className="badge-item">
                                                  <div className="badge-icon">{userData?.emailVerified ? "✔" : "×"}</div>
                                                  <div className="badge-text">
                                                       <strong>{userData?.emailVerified ? "Email Verified" : "Email Not Verified"}</strong>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>


                                   <div className="section">
                                        <h3>Social Media</h3>

                                        {userData?.social &&
                                             Object.values(userData.social).some(link => link && link.trim() !== "") ? (

                                             <div className="social-links">
                                                  {Object.entries(userData.social).map(([key, value]) => {
                                                       if (!value || value.trim() === "") return null;

                                                       return (
                                                            <Link
                                                                 key={key}
                                                                 to={value}
                                                                 target="_blank"
                                                                 rel="noopener noreferrer"
                                                            >
                                                                 {socialIcons[key]}
                                                            </Link>
                                                       );
                                                  })}
                                             </div>

                                        ) : (
                                             <p className="no-social">No social media links available</p>
                                        )}

                                   </div>

                                   <div className="buttons">
                                        <Link to="/submit" className="btn-main"> <Upload /> Submit new prompt </Link>
                                        <button onClick={() => handleLogout('/login')} type='button' className="btn-secondary">Sign out</button>
                                   </div>
                              </TabPanel>


                              <TabPanel>
                                   <div className="payment-tab">

                                        {/* PLAN INFORMATION */}



                                        {userData?.subscriptions === "paid" &&
                                             <>
                                                  <div className="payment-card earnings-card">
                                                       <h3>Earnings Overview</h3>

                                                       <div className="stats-grid">
                                                            <div className="stat">
                                                                 <h4>{userData?.prompt || 0}</h4>
                                                                 <span>Total Prompts</span>
                                                            </div>

                                                            <Prompt24Item
                                                                 userData={userData}
                                                                 render={(count) => (
                                                                      <div className="stat">
                                                                           <h4>{10 - count}</h4>
                                                                           <span>Pending Submissions Prompt</span>
                                                                      </div>
                                                                 )} />
                                                            <div className="stat highlight">
                                                                 <h4>{userData?.totalEarnings}</h4>
                                                                 <span>Total Points</span>
                                                            </div>
                                                       </div>
                                                  </div>

                                                  <div className="payment-card plan-card">
                                                       <h3>Subscription Details</h3>

                                                       <div className="plan-grid">
                                                            <div>
                                                                 <span>Status</span>
                                                                 <p className={userData?.subscriptions === "paid" ? "active" : "inactive"}>
                                                                      {userData?.subscriptions.toUpperCase() || "FREE USER"}
                                                                 </p>
                                                            </div>

                                                            <div>
                                                                 <span>Plan</span>
                                                                 <p>{userData?.planDetails?.planTitle || "No Plan Selected"}</p>
                                                            </div>

                                                            <div>
                                                                 <span>Amount Paid</span>
                                                                 <p>{userData?.planDetails?.amountPaid || "₹0"}</p>
                                                            </div>

                                                            <div>
                                                                 <span>Started On</span>
                                                                 <p>{userData?.planDetails?.planTimestamp ? new Date(userData?.planDetails?.planTimestamp).toDateString() : "N/A"}</p>
                                                            </div>
                                                            <div>
                                                                 <span>Expiry Date</span>
                                                                 <p>{userData?.planDetails?.expiryAt ? new Date(userData?.planDetails?.expiryAt).toLocaleDateString() : "N/A"}</p>
                                                            </div>
                                                       </div>
                                                  </div>



                                             </>
                                        }

                                        <div className="payment-card info-card">
                                             <h3>Performance</h3>
                                             {userData?.subscriptions === "paid" ? (
                                                  <>
                                                       <p>
                                                            You are currently on a <strong>{userData?.planDetails?.planTitle}</strong> plan.
                                                            Keep posting quality prompts to increase your visibility and grow your earnings.

                                                       </p>
                                                       <Link to="/submit" className="renew-btn">Submit quality prompts </Link>

                                                  </>
                                             ) : (
                                                  <>
                                                       <p>You are currently on a <strong>Free Plan</strong>.
                                                            Upgrade your account to unlock premium features, better reach,
                                                            and start earning from your prompts.</p>

                                                       <Link to="/marketplace" className="renew-btn">Upgrade / Renew Plan</Link>

                                                  </>
                                             )}

                                        </div>

                                   </div>
                              </TabPanel>
                         </Tabs>
                    </div>
               </div>

               <Profile
                    message={message}
                    setMessage={setMessage}
                    show={show}
                    handleClose={handleClose} />

          </>
     );
}

export default ProfilePreview;
